import { makeAutoObservable } from "mobx";

class TickerStore {
  subscriptions = new Map<string, number>();
  prices = new Map<string, number>();

  constructor() {
    makeAutoObservable(this);
  }

  subscribe(symbol: string) {
    this.subscriptions.set(symbol, (this.subscriptions.get(symbol) || 0) + 1);
  }

  unsubscribe(symbol: string) {
    const count = (this.subscriptions.get(symbol) || 0) - 1;
    if (count <= 0) this.subscriptions.delete(symbol);
    else this.subscriptions.set(symbol, count);
  }

  updatePrice(symbol: string, price: number) {
    this.prices.set(symbol, price);
  }

  reset() {
    this.subscriptions.clear();
    this.prices.clear();
  }
}

export const tickerStore = new TickerStore();
